/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIContract } from './APIContract';
import {
    APIContractFromJSON,
    APIContractFromJSONTyped,
    APIContractToJSON,
} from './APIContract';

/**
 * 
 * @export
 * @interface APIPaginatedContractList
 */
export interface APIPaginatedContractList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedContractList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedContractList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedContractList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIContract>}
     * @memberof APIPaginatedContractList
     */
    results: Array<APIContract>;
}

/**
 * Check if a given object implements the APIPaginatedContractList interface.
 */
export function instanceOfAPIPaginatedContractList(value: object): value is APIPaginatedContractList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedContractListFromJSON(json: any): APIPaginatedContractList {
    return APIPaginatedContractListFromJSONTyped(json, false);
}

export function APIPaginatedContractListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedContractList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIContractFromJSON)),
    };
}

export function APIPaginatedContractListToJSON(value?: APIPaginatedContractList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIContractToJSON)),
    };
}

